module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_lock-e2ed492b088e2cfec68d28953d38a136.svg";